<template>
  <div id="selectBranch">
    <el-select
      v-model="userDeptRoleId"
      :class="[
        checkCurrentActive() ? '' : 'current-lock-account',
        'style-fullWidth',
      ]"
      size="medium"
      filterable
      @change="userDeptRoleIdChange"
    >
      <el-option
        :label="buildUserDeptRoleLabel(item)"
        v-for="item in userDeptRoles_"
        :key="item.id"
        :value="item.id"
        :class="[checkActive(item) ? '' : 'lock-account', '']"
      >
        <div class="signerItem font-size__small">
          <span class="signerInfo font-weight__regular">{{
            buildUserDeptRoleLabel(item)
          }}</span>
          <i v-if="!checkActive(item)" class="fas fa-user-lock"></i></div
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import constants from "../../constants";
import { EventBus } from "../../event-bus";

export default {
  name: "select-branch",
  data() {
    return {
      userDeptRoleId: null,
      userDeptRoles_: null,
    };
  },
  computed: {
    userDeptRoleId_() {
      return this.$route.params.userDeptRoleId;
    },
    userDeptRoles() {
      return this.$store.getters.userDeptRoles;
    },
  },
  watch: {
    userDeptRoles(newValue) {
      this.initUserDeptRoles(newValue);
    },
    userDeptRoleId_(newValue) {
      if (newValue && this.userDeptRoleId !== newValue) {
        this.userDeptRoleId = newValue;
        this.$store.commit("changeUserDeptRole", this.userDeptRoleId);
      }
    },
  },
  created() {
    this.userDeptRoleId = this.$store.getters.userDeptRoleId;
    this.initUserDeptRoles(this.userDeptRoles);
    this.registerUserDeptRoleChangeListener();
  },
  methods: {
    initUserDeptRoles(userDeptRoles) {
      this.userDeptRoles_ = [];
      this.userDeptRoles_.push(...(userDeptRoles || []));
      // this.userDeptRoles_.sort((item1, item2) => {
      //   return this.buildUserDeptRoleLabel(item1).localeCompare(
      //     this.buildUserDeptRoleLabel(item2)
      //   );
      // });
    },

    registerUserDeptRoleChangeListener() {
      EventBus.$on(
        constants.EVENT_BUS.CHANGE_USER_DEPT_ROLE,
        (options) => (this.userDeptRoleId = options.userDeptRoleId)
      );
    },

    buildUserDeptRoleLabel(userDeptRole) {
      return userDeptRole.positionName + " - " + (userDeptRole.deptName || "");
    },

    checkActive(userDeptRole) {
      return (
        userDeptRole &&
        userDeptRole.status === "active" &&
        userDeptRole.deptStatus === "active"
      );
    },

    checkCurrentActive() {
      return (
        this.$store.getters.userDeptRole &&
        this.$store.getters.userDeptRole.status === "active" &&
        this.$store.getters.userDeptRole.deptStatus === "active"
      );
    },

    userDeptRoleIdChange() {
      this.$store.commit("changeUserDeptRole", this.userDeptRoleId);
      this.$router.replace({
        name: "dashboard",
        params: { userDeptRoleId: this.userDeptRoleId },
      });
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/menu-left/select-branch.vue